import styles from './styles';

import * as React from 'react';

import { action } from 'mobx';
import { inject, observer } from 'mobx-react';

import type { WithStyles } from '@material-ui/core';

import type AuthStore from 'connect/web/src/stores/auth-store';
import type HistoryStore from 'connect/web/src/stores/history-store';
import type HeaderStore from '../../stores/header-store';

import { withStyles } from '@material-ui/core';
import { AnalyticsEvents } from 'connect/core/enums/analytics-enum';
import type ProviderStore from 'src/stores/provider-store';

interface IProps extends WithStyles<typeof styles> {
  text: string;
  path: string;
  tabIndex?: number;

  authStore?: AuthStore;
  headerStore?: HeaderStore;
  historyStore?: HistoryStore;
  providerStore?: ProviderStore;

  onClick?: () => void;
}

@inject('historyStore', 'authStore', 'headerStore', 'providerStore')
@observer
class NavButton extends React.Component<IProps> {
  render() {
    const { classes, tabIndex, text } = this.props;
    const { navButton, navButtonText } = classes;

    return (
      <div
        aria-hidden={false}
        aria-label={text}
        className={navButton}
        role="button"
        tabIndex={tabIndex}
        onClick={this.onClick}
      >
        <div className={navButtonText}>{text}</div>
      </div>
    );
  }

  @action.bound
  onClick() {
    let { historyStore, authStore, path, onClick, headerStore, providerStore } = this.props;

    if (path === '/logout') {
      authStore!.logout();
      historyStore!.push('/');

      providerStore!.sendAnalyticsEvent(AnalyticsEvents.Logout, {
        category: 'User',
        action: 'Log Out successful',
        label: 'user-log-out-success'
      });

      return;
    }

    onClick?.();
    historyStore!.push(path);
    headerStore!.menuOpen = false;
  }
}

export default withStyles(styles)(NavButton);
